import { Button } from '@nexelem/components';
import { Link } from 'react-router-dom';
import { EmptyStatePage } from '../../../../EmptyStatePage';
import { useCustomTranslation } from '../../../../../../hooks';
import { ROUTES } from '../../../../../../routes/config';

export const EmptyState = () => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');

  return (
    <EmptyStatePage
      headerTitle={tWrapper('title')}
      text={tWrapper('simulationListEmpty')}
      Actions={
        <Button component={Link} to={ROUTES.plan.simulationCreatePath} variant="contained">
          {tWrapper('createSimulation')}
        </Button>
      }
    />
  );
};
